import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useModal } from '../../Providers/ModalContext';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const Container = styled.div`
  padding: 20px 0px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;

  @media ${breakpoints.mobile}) {
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
  }
`;

const Card = styled.div`
  overflow: hidden;

  ${({ $widthPercent }) =>
    $widthPercent &&
    `
      grid-column: span ${Math.round(($widthPercent / 100) * 5)};
  `}
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

export default function ImageGrid({ images = [] }) {
  const [imageData, setImageData] = useState([]);
  const { openModal } = useModal();

  const handleClick = (img) => {
    const target = img.target || 'portfolio-films';
    const item = img.id ? { item: img.id } : {};
    openModal(target, item);
  };

  useEffect(() => {
    let active = true;

    const loadImages = async () => {
      const promises = images.map((imgObj) => {
        const { src } = imgObj;
        return new Promise((resolve) => {
          const img = new Image();
          img.src = src;
          img.onload = () => {
            resolve({
              ...imgObj,
              naturalWidth: img.naturalWidth,
              naturalHeight: img.naturalHeight,
            });
          };
        });
      });

      const results = await Promise.all(promises);
      if (active) setImageData(results);
    };

    loadImages();
    return () => {
      active = false;
    };
  }, [images]);

  return (
    <Container>
      <Grid>
        {imageData.map((img, index) => (
          <Card key={index} $widthPercent={img.widthPercent}>
            <StyledImage
              src={img.src}
              width={img.naturalWidth}
              height={img.naturalHeight}
              alt=""
              loading="lazy"
              style={{ cursor: 'pointer' }}
              onClick={() => handleClick(img)}
            />
          </Card>
        ))}
      </Grid>
    </Container>
  );
}
